export default __webpack_public_path__ + "static/media/sem.77879d3b.svg";